import type { IconData } from '@stacksjs/iconify-core'

export const extinguisher: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9.45 4.145A2 2 0 0 1 6.067 4H4a2 2 0 0 0-2 2v3a1 1 0 1 1-2 0V6a4 4 0 0 1 4-4h2.077a2 2 0 0 1 3.381-.117A1 1 0 0 1 11.45 2h1.311L18.722.036l.003.002a1 1 0 0 1 1.273.906L20 .945v3.992l-.002.001L20 5a1 1 0 0 1-1.275.962l-.003.002L12.892 4H11.45v1.009q0 .045-.004.09A4.5 4.5 0 0 1 15 9.5V17a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V9.5a4.5 4.5 0 0 1 3.457-4.378a1 1 0 0 1-.007-.113zm8.597-.471V2.436l-1.866.597zM10.5 7A2.5 2.5 0 0 0 8 9.5V17a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V9.5A2.5 2.5 0 0 0 10.5 7\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default extinguisher
